function MediaFormatError(message) {
  this.name = 'Unsupported Media Format';
  this.message = message || 'We do not support this media format.';

  // See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error
  this.stack = new Error().stack;
}

MediaFormatError.prototype = Object.create(Error.prototype);
MediaFormatError.prototype.constructor = MediaFormatError;

export default MediaFormatError;
